import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const TENANTMANAGEMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/tenantmanagement',
        iconClass: 'fas fa-users',
        order : 110,
        name: '::Menu:TenantManagement',
        layout: eLayoutType.application,
        requiredPolicy: 'Ldm.SubscriptionTenants',
      },
    ]);
  };
}
